import {
  smartApplyPartners,
  type SmartApplyPartnerConfigKey
} from '@percent/cause-dashboard/constants/smartApplyPartners'

/**
 * Resolves a Storyblok native-apply partner reference to a known partner key.
 *
 * Storyblok datasource fields are typed as `number | string` and may be missing,
 * unresolved, or refer to a partner we don't yet support on the FE. Treat every
 * input as untrusted and return `null` when we cannot map it confidently — callers
 * use the `null` to skip rendering the CTA or to abort submission with a toast.
 */
export function resolveNativeApplyPartnerKey(
  raw: number | string | undefined | null
): SmartApplyPartnerConfigKey | null {
  if (typeof raw !== 'string') {
    return null
  }
  const key = raw.trim()
  if (!key) {
    return null
  }
  return key in smartApplyPartners ? (key as SmartApplyPartnerConfigKey) : null
}
